import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { reload, loadPage, reset } from "./branchesSlice";
import { Modal, Typography } from "antd";
import NewbranchWizard from "./newBranch/NewbranchWizard";
import ActionsTable from "../../components/templates/ActionsTable";
import Phone from "../../components/tables/Phone";
import Address from "../../components/tables/Address";
import Actions from "../../components/tables/Actions";
import LinkComponent from "../../components/tables/Link";
import Surface from "../../components/layouts/Surface";
import { ReactComponent as BranchesImg } from "../../assets/no-branches.svg";
import { useLocation } from "react-router-dom";
import { useBranchGroups } from "../../hooks/index";
const { Text } = Typography;
const BranchesList = () => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  let location = useLocation();
  const { page: branchesPage } = useSelector((state) => state.branches);
  const { current, pageSize, total, order, items, filter } = branchesPage;
  const loading = useSelector(
    (state) => state.pendingActions["branches/loadPage"]
  );
  const intl = useIntl();
  let history = useHistory();
  const branchGroups = useBranchGroups();
  const onNavigateClicked = (record) => {
    const url = location.pathname + "/" + record.id;
    history.push(url);
  };

  const onTextChange = (e) => {
    dispatch(
      loadPage({ current: 1, filter: { ...filter, freeText: e.target.value } })
    );
  };

  const onAddClick = () => {
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };

  return (
    <Surface>
      <ActionsTable
        tableItems={[
          {
            title: "name",
            responsive: ["xl"],
            sortIndex: "name",
            sorter: true,
            render: LinkComponent,
            columnProps: {
              pathTarget: "branch",
            },
          },
          {
            title: "group_id",
            responsive: ["xl"],
            sortIndex: "group_id",
            sorter: true,
            render: ({ record }) => {
              return <Text>{record["group.name"]}</Text>;
            },
            filters: branchGroups.map((i) => {
              return { text: i.name, value: i.id };
            }),
          },
          {
            title: "phone_number",
            responsive: ["md"],
            width: 150,
            render: Phone,
          },
          {
            title: "mobile_number",
            responsive: ["xxl"],
            width: 150,
            render: Phone,
          },
          {
            title: "branch_address",
            responsive: ["md"],
            ellipsis: true,
            render: Address,
          },
          { title: "email", responsive: ["xxl"], ellipsis: true },
          {
            title: "actions",
            responsive: ["md"],
            render: Actions,
            columnProps: {
              onFirstClicked: onNavigateClicked,
              firstActionText: "goToBranch",
              firstActionType: "normal",
              category: "branches",
            },
          },
        ]}
        ltrItems={["phone_number", "mobile_number"]}
        category={"branches"}
        resource="branches"
        current={current}
        pageSize={pageSize}
        total={total}
        loading={loading}
        textFilter={filter.freeText}
        reload={reload}
        loadPage={loadPage}
        resetPage={reset}
        items={items}
        onTextChange={onTextChange}
        onAddClick={onAddClick}
        addbuttonText={<FormattedMessage id="app.branches.addNewBranch" />}
        headerInputPlaceholder={intl.formatMessage({
          id: "app.branches.typeClientName",
        })}
        showheader={true}
        filtersType={{
          group_id: "number",
        }}
        linkType={"branches"}
        // emptyImage={<BranchesImg />}
        // emptytext={<FormattedMessage id="app.tables.noBranches" />}
      />
      <Modal
        closable={false}
        maskClosable={false}
        footer={null}
        width={"1100px"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        title={null}
        open={visible}
        onCancel={hide}
        destroyOnClose={true}
      >
        <NewbranchWizard hideWizard={hide} />
      </Modal>
    </Surface>
  );
};

export default BranchesList;
